  // Function to automatically add a product to the cart based on the total sum
  function autoAddProductToCart() {
    // Define the product variant ID that you want to add to the cart
    var productVariantId = '47117386940756';
    
    // // Define the total sum required to trigger the auto-add
    var requiredTotal = 500; // Change this to your desired total
    //Fetch the current cart
    fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        
        // var cartTotal = cart.total_price / 100; 
        let items = cart.items;
        let condition = items.length > 0 ? items.some((item) => item.variant_id == productVariantId) : null;
        
      })
      .catch((error) => {
        console.error('Error fetching cart: ', error);
      });
  }

  // Call the function when the page loads or when needed
  autoAddProductToCart();
